import React, { useState } from 'react';
import { Home, Briefcase, Plus, Users, Upload, Target, BarChart2, Settings } from 'lucide-react';
import { NavLink } from 'react-router-dom';

const items = [
	{ to: '/company/dashboard', label: 'Dashboard', icon: Home },
	{ to: '/company/jobs', label: 'Job Postings', icon: Briefcase },
	{ to: '/company/jobs/new', label: 'Post New Job', icon: Plus },
	{ to: '/company/resumes', label: 'Candidate Database', icon: Users },
	{ to: '/company/resumes/upload', label: 'Upload Resumes', icon: Upload },
	{ to: '/company/match', label: 'Match Candidates', icon: Target },
	{ to: '/company/analytics', label: 'Analytics', icon: BarChart2 },
	{ to: '/company/settings', label: 'Settings', icon: Settings }
];

export default function CompanySidebar() {
	const [collapsed, setCollapsed] = useState(false);
	const linkClass = ({ isActive }) => `flex items-center gap-3 px-3 py-2 rounded-md text-sm ${isActive ? 'bg-blue-50 text-blue-700' : 'text-gray-700 hover:bg-gray-50'}`;
	return (
		<aside className={`bg-white border-r h-full ${collapsed ? 'w-16' : 'w-60'} transition-all`}>
			<div className="p-2 flex justify-end">
				<button className="p-1 rounded hover:bg-gray-100" onClick={() => setCollapsed((v) => !v)} aria-label="Toggle sidebar">
					{collapsed ? '»' : '«'}
				</button>
			</div>
			<nav className="px-2 space-y-1">
				{items.map(({ to, label, icon: Icon }) => (
					<NavLink key={to} to={to} className={linkClass}>
						<Icon className="w-5 h-5" />
						{!collapsed && <span>{label}</span>}
					</NavLink>
				))}
			</nav>
		</aside>
	);
}


